import {useEffect, useState} from 'react';
import {useEvent} from './use-event';

type Props = {
  initialTime?: number;
  enabled?: boolean;
  onFinish?: () => void;
};

export const useCountdown = ({initialTime, enabled = true, onFinish}: Props = {}) => {
  const duration = initialTime ?? 60;
  const [timeLeft, setTimeLeft] = useState(duration);
  const [isTimerRunning, setIsTimerRunning] = useState(enabled);
  const handleOnFinish = useEvent(onFinish);

  useEffect(() => {
    setTimeLeft(duration);
    setIsTimerRunning(enabled);
  }, [duration, enabled]);

  useEffect(() => {
    if (!isTimerRunning) return;

    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 1) {
          clearInterval(timer);
          setIsTimerRunning(false);
          return 0;
        }

        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [isTimerRunning]);

  useEffect(() => {
    if (timeLeft <= 0) {
      handleOnFinish();
    }
  }, [timeLeft, handleOnFinish]);

  const resetTimer = () => {
    setTimeLeft(duration);
    setIsTimerRunning(enabled);
  };

  return {
    timeLeft,
    isTimerRunning,
    resetTimer,
  };
};
